<template lang="pug">
  .involved-dialog-container(v-if="show", @touchmove.prevent)
    .shadow(@click="close")
    .dialog-content
      .box
        .title {{getTitleText()}}
        .date {{involovedData.lotteryDateDesc || ''}}
        .time {{involovedData.lotteryTimeDesc || ''}} 开奖
      .btn(@click="close") 知道了
      .close(@click="close")
</template>
<script>

import { env } from '@hb/hbridge';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    involovedData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
    };
  },
  watch: {
  },
  created() {

  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    },
    getTitleText() {
      const batchNo = this.involovedData.batchNo || '';
      const prizeName = (this.involovedData.prizes && this.involovedData.prizes[0] && this.involovedData.prizes[0].prizeName) || '';
      return `${batchNo} ${prizeName}`;
    },
  },
};
</script>

<style lang="less" scoped>
.involved-dialog-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .shadow {
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.7;
    position: absolute;
    left: 0;
    top: 0;
  }

  .dialog-content {
    width: 3.03rem;
    height: 3.91rem;
    z-index: 1;

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 3.03rem;
      height: 2.58rem;
      background-image: url('https://m.hellobike.com/resource/gallery/833/hSlYNrmiF4.png');
      background-size: 100%;
      background-repeat: no-repeat;
      padding-top: 0.87rem;

      .title {
        font-weight: 600;
        font-size: 0.14rem;
        color: #7d3b2a;
      }

      .date {
        margin-top: 0.33rem;
        font-weight: 600;
        font-size: 0.24rem;
      }

      .time {
        position: relative;
        font-weight: 600;
        font-size: 0.18rem;
        color: #f41717;
        margin-top: 0.12rem;

        &::before,
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 0.096rem;
          height: 0.106rem;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        &::before {
          left: -0.22rem;
          background-image: url('https://m.hellobike.com/resource/gallery/833/RVxU5ARj_Polygon%201.png');
        }

        &::after {
          right: -0.22rem;
          background-image: url('https://m.hellobike.com/resource/gallery/833/i5zmYM78_Polygon%203.png');
        }
      }
    }

    .btn {
      width: 1.11rem;
      height: 0.4rem;
      margin: 0.15rem auto 0;
      background-color: #fb990f;
      border-radius: 0.32rem;
      font-weight: 600;
      font-size: 0.14rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }

    .close {
      width: 0.3rem;
      height: 0.3rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/Hgiou4vp_close.png);
      background-size: 100%;
      background-repeat: no-repeat;
      margin: 0.48rem auto 0;
    }
  }
}
</style>
